import { render, staticRenderFns } from "./item-manufacture.vue?vue&type=template&id=1eda0b36&scoped=true&"
import script from "./item-manufacture.js?vue&type=script&lang=js&"
export * from "./item-manufacture.js?vue&type=script&lang=js&"
import style0 from "./item-manufacture.scss?vue&type=style&index=0&id=1eda0b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eda0b36",
  null
  
)

export default component.exports